import { render, staticRenderFns } from "./update-recruitment-last-date-modal.vue?vue&type=template&id=08ed9d3e&scoped=true"
import script from "./update-recruitment-last-date-modal.vue?vue&type=script&lang=js"
export * from "./update-recruitment-last-date-modal.vue?vue&type=script&lang=js"
import style0 from "./update-recruitment-last-date-modal.vue?vue&type=style&index=0&id=08ed9d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed9d3e",
  null
  
)

export default component.exports